/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_viewer = {
    readonly isFavoritesEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer" | "BuySharedItemTrackingProvider_viewer">;
    readonly " $refType": "BuySharedResultContainer_viewer";
};
export type BuySharedResultContainer_viewer$data = BuySharedResultContainer_viewer;
export type BuySharedResultContainer_viewer$key = {
    readonly " $data"?: BuySharedResultContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedResultContainer_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedResultContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BuySharedItemTrackingProvider_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'cf22471f64886f9343f50684fb2e0fc9';
export default node;
